import React, { useEffect, /*useContext, */useState } from 'react'
import PageHeader from '../helper/PageHeader';
import { useHistory, useParams } from 'react-router'
import SimpleTable from '../helper/SimpleTable';
//import { authContext } from '../../context/AuthContext';
import { withTranslation } from 'react-i18next';

import Loading from '../helper/Loading';
import axios from 'axios';


  import { Link } from 'react-router-dom'

const CreditHistory = props => {
    const history = useHistory()   
    const params = useParams()
    //const context = useContext(authContext)

    const [availableCredit, setAvailableCredit] = useState(null);
    const [name, setName] = useState(null);
    const [data, setData] = useState(null);


    const {t} = props;

    const tableCells = [
        { id: 'createDate', label: t('CreditHistory.Date'), centered: false },
        { id: 'actionText', label: t('CreditHistory.Action'), centered: false },
        { id: 'amount', label: t('CreditHistory.Amount'), centered: false },
        { id: 'notes', label: t('CreditHistory.Notes'), centered: false },
        { id: 'createdByUsername', label: t('CreditHistory.By'), centered: false }
    ];

    useEffect(() => {
        async function getData() {
            let credit = await axios.get('/api/credit/log/'+ params.id, {});
            console.log(credit);
            setData(credit.data);

            
            if (params.type === 'employer') {
                let employer = await axios.get('/api/credit/employer/'+ params.id, {});
                setAvailableCredit(employer.data.credit)
                setName(employer.data.name);    

            } else {
                let user = await axios.get('/api/user/credit/'+ params.id, {});
                setAvailableCredit(user.data.user.credit)
                setName(user.data.user.first_name + ' ' + user.data.user.last_name)        
            }        
        }
        getData();
    },[params.id, params.type])
   

    return (
        <>
            <PageHeader title={name + " " + t('CreditHistory.CreditHistoryD') }
                cancel={history.goBack} 
            />

            <p> {t('CreditHistory.Name') } {name}</p>
            <p> {t('CreditHistory.AvailableCredit') }  {availableCredit}</p>

            <p>Purchase history before May 29, 2023 is not available online. If you need earlier purchase records, please contact the GI-BMP Office at <a href="mailto:gi.bmp@ifas.ufl.edu">gi.bmp@ifas.ufl.edu</a> or 352-273-4517.</p>
           {
                (params.type === 'user') &&
                  <p>To view your purchase for an employer, please go to the  <Link to={"/dashboard/employers/" +params.id}>For Employers tab</Link>, select the employer and click on Purchase History</p>

           }
          
            {data === null ? <Loading /> :
                data.length === 0 ? <h1>{t('CreditHistory.NoCreditHistory') } </h1> :
                    <>
                        <SimpleTable
                            data={data}
                            cellKey={"ID"}
                            tableCells={tableCells}
                            actions={false}
                        />
                    </>
            }

        </>
    )
}

export default withTranslation()(CreditHistory);